declare const window: any;
export const initializeA8FormsV3TypeDefs = () => {
  const a8FormsV3Defs = `
        interface IComponentV3 extends IV3AssetMutate {
          asset: (assetInstanceId: string) => IComponentV3
        }

        type Asset = IComponentV3

        interface IV3AssetMutate {
          asset: (assetInstanceId: string) => Asset;
          importAsset: (assetId: string, options: { bindPrefix: string, after?: string }) => string;
          deleteAsset: (assetInstaceId: string) => void;
        }
           // this interface will be dynamically populated by marketplace
        // core and third-party plugins
        interface IComponentV3 {
         Container: (id: string) => IAssetMutate
         Section: (id: string) => IAssetMutate
        }
        declare var a8formsV3: IA8V3Forms`

  window.a8FormsV3TypeDefs = a8FormsV3Defs
}

export default function a8formsV3() {
  return `
        ${window.a8FormsV3TypeDefs}
         type IA8V3Forms =  IComponentV3;
    `
}
